module.exports = __webpack_public_path__ + "img/c08_unitturanga_Normal_ua.5976bc84.webp";